module.exports = "<div class=\"container-fluid\" *ngIf=\"this.breadcrumbService.breadcrumbs\">\n\t<ol class=\"breadcrumb\">\n\t\t<li *ngFor=\"let breadcrumb of this.breadcrumbService.breadcrumbs\" [routerLink]=\"[breadcrumb.url]\">\n\t\t\t{{breadcrumb.label | breadcrumbTrans}}\n\t\t</li>\n\t</ol>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/breadcrumb/breadcrumb.template.html
// module id = ./src/app/breadcrumb/breadcrumb.template.html
// module chunks = main